import moment from "moment-timezone";
import map from "lodash/map";
import * as _ from "lodash";

import { getLocalTimeZone } from "../date-helpers";

export const times = () => {
  return map(Array(24), (_, i) => {
    const time = moment.utc(i, "H").format("HH:mm");

    return {
      text: time,
      value: time
    };
  });
};

export const dayHours = Array.from(Array(24).keys()).map(hour => {
  const stringHour = hour.toString();

  if (stringHour.length === 1) {
    return `0${stringHour}`;
  }

  return stringHour;
});

export const dayMinutes = Array.from(Array(60).keys()).map(min => {
  const stringMin = min.toString();

  if (stringMin.length === 1) {
    return `0${stringMin}`;
  }

  return stringMin;
});

/**
 *
 * @param time Splits a time into hours and minutes
 */
export const hourMinuteTimeSplit = (time: string): { hours: number; minutes: number } => {
  const split = time.split(":");

  return {
    hours: parseInt(split[ 0 ]),
    minutes: parseInt(split[ 1 ])
  };
};

/**
 *
 * @param time Splits a time into hours and minutes
 */
export const toLocalTime = (hoursMinutes: string, originTimezone: string): string => {
  const { hours, minutes } = hourMinuteTimeSplit(hoursMinutes);
  const timeZone = getLocalTimeZone();

  const utcDate = moment
    .tz(originTimezone)
    .hours(hours)
    .minutes(minutes)
    .toDate();

  if (timeZone) {
    hoursMinutes = moment(utcDate)
      .tz(timeZone.name)
      .format("HH:mm");
  }

  return hoursMinutes;
};

/**
 * Takes total minutes and returns either hh:mm or X hours, Y minutes
 * @param totalMinutes number
 * @param format "short" | "long"
 */
export const minutesToHHMM = (totalMinutes: number, format?: "short" | "long"): string => {
  if (!format) {
    format = "short";
  }

  if (totalMinutes === 0) {
    return format === "short" ? "0:00" : "0 minutes";
  }

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  let formatedHours = hours.toString();
  let formatedMinutes = minutes.toString();

  if (format === "short") {
    if (hours < 10) {
      formatedHours = `0${hours}`;
    }

    if (minutes < 10) {
      formatedMinutes = `0${minutes}`;
    }

    return `${formatedHours}:${formatedMinutes}`;
  } else {
    if (hours === 0) {
      return `${minutes} minutes`;
    }

    const hoursString = hours === 1 ? "1 hour" : `${hours} hours`;
    const minutesString = minutes === 1 ? "1 minute" : `${minutes} minutes`;

    // if we get this far, we know we have hours
    if (minutes === 0) {
      // no need to display "0 minutes"
      return hoursString;
    }

    return `${hoursString}, ${minutesString}`;
  }
};